import { defineStore } from 'pinia';
import axios from 'axios';

export const useFrankStore = defineStore('frankStore', {
    state: () => ({
        product: null,
        apiUrls: {
            energy: 'https://api-energie.keuze.nl/v1/feedback/yZv4mJs9qTfWcQz6-554',
            internet: 'https://api-internet.keuze.nl/v1/feedback/5Jm0k9yn1oQqCz6I-268',
        },
        comparer: null,
        timeOut: 1000,
        token: null,
        submitted: false,
        positive: true,
        showFrank: false,
        step: 1,
        rating: 3,
        feedback: {
            name: '',
            email: '',
            message: '',
            improvements: [],
        },
        improvement_options: [
            {
                label: 'Ik moet er nog even over nadenken',
                value: 'need_time',
            },
            {
                label: 'De prijzen kloppen niet',
                value: 'wrong_price',
            },
            {
                label: 'Onduidelijke site van leverancier',
                value: 'website_unclear',
            },
            {
                label: 'Iets anders',
                value: 'other',
            },
        ],
    }),
    actions: {
        resetFrank() {
            this.product = null;
            this.token = null;
            this.submitted = false;
            this.positive = true;
            this.showFrank = false;
            this.step = 1;
            this.rating = 3;
            this.feedback = {
                name: '',
                email: '',
                message: '',
                improvements: [],
            };
        },
        setFrankComparer(comparer) {
            this.comparer = comparer;
        },
        setFrankProduct(product) {
            this.resetFrank();
            this.product = product;
            setTimeout(() => {
                this.showFrank = true;
            }, this.timeOut);
        },
        positiveFlow() {
            this.positive = true;
            this.step = 2;
        },
        negativeFlow() {
            this.positive = false;
            this.step = 2;
        },
        closeFrank() {
            this.resetFrank();
            this.showFrank = false;
        },
        goBack() {
            this.step = 1;
        },
        submitFeedback() {
            const apiUrl = this.apiUrls[this.comparer];

            if (typeof window.bananas !== 'undefined') {
                this.channel = window.bananas('channel');
            }

            const feedbackMsg = {
                base_product_id: this.product.base_id,
                rank: this.product.rank,
                positive: this.positive,
                filters: this.filters,
                page_url: window.location.href,
                name: this.feedback.name,
                remark: this.feedback.message,
                email: this.feedback.email,
                improvement_reasons: this.feedback.improvements,
                score: this.rating,
                token: this.token,
                channel: this.channel,
            };
            if (import.meta.env.DEV) {
                alert("DEV mode api submitted");
                this.submitted = true;
                this.step = 3;
            } else {
                axios
                    .post(apiUrl, feedbackMsg)
                    .then((response) => {
                        this.submitted = true;
                        this.step = 3;
                        this.token = response.data.token;
                    });
            }

            this.submitted = true;
            this.step = 3;
        },
    },
});
